
// Substitutes the value of a stored model by matching a property of that model to a string delimited by '[[' and ']]'
export default class BCMSTemplate {

  // CONSTRUCTOR :: OBJECT -> this
  constructor(model) {
    this.model = model;
  }

  // :: STRING -> STRING
  // String to apply template to:
  applyTo(str, error) {
    return this.getMatchedValues(str).reduce((result, matchedValue) => {
      let property = this.removeDelimiters(matchedValue);
      let value = this.model[property];

      if(value === undefined && error instanceof Function) {
        error(property);
      }

      return result.replace(matchedValue, value);
    }, str);
  }

  // :: STRING -> [STRING|VOID]
  // Returns array of strings that are delimited by '[[' and ']]'
  getMatchedValues(str) {
    return str.match(/\[\[(.*?)\]\]/g) ?? [];
  }

  // :: STRING -> STRING
  // Removes '[[' and ']]' from STRING
  removeDelimiters(str) {
    return str.substring(2, str.length - 2);
  }

  /**
   *
   *  Static Methods
   *
   */

   // Static factory method :: OBJECT -> bcmsTemplate
   static init(model) {
     return new BCMSTemplate(model);
   }

}
